jQuery(function ($) {

    // --- popup logic (your code, unchanged) ---
    $('.wishlist-popup-trigger').on('click', function (e) {
        e.preventDefault();
        $('#wishlist-popup').addClass('wishlist-popup-trigger-show');
        $('html').addClass('overflow-hidden');
    });

    $('body').on('click', '#wishlist-popup', function (e) {
        if (e.target === this || $(e.target).closest('.icon-close').length) {
            $('#wishlist-popup').removeClass('wishlist-popup-trigger-show');
            $('html').removeClass('overflow-hidden');
        }
    });

    // --- helpers ---
    function getAjaxUrl() {
        return (window.yith_wcwl_l10n && window.yith_wcwl_l10n.ajax_url)
            || window.ajaxurl
            || '/wp-admin/admin-ajax.php';
    }

    function getBadgeEl() {
        // In your header template .wishlist-icon is used for BOTH svg and image-icon wrapper.
        // This selector should match both.
        return $('.header-wishlist-icon .wishlist-icon').first();
    }

    function applyCountToHeader(count) {
        var $badge = getBadgeEl();
        if (!$badge.length) {
            console.log('[Wishlist header] badge element NOT found: .header-wishlist-icon .wishlist-icon');
            return;
        }

        var safeCount = parseInt(count, 10);
        if (isNaN(safeCount) || safeCount < 0) safeCount = 0;

        // console.log('[Wishlist header] applying count =', safeCount, 'to', $badge.get(0));

        if (safeCount > 0) {
            $badge.addClass('has-products').attr('data-icon-label', String(safeCount));
        } else {
            $badge.removeClass('has-products').removeAttr('data-icon-label');
        }
    }

    function updateHeaderWishlistCount(reason) {
        // console.log('[Wishlist header] updateHeaderWishlistCount()', reason || '');

        $.ajax({
            url: getAjaxUrl(),
            type: 'POST',
            dataType: 'json',
            data: { action: 'fl_get_wishlist_count' },
            success: function (res) {
                // console.log('[Wishlist header] ajax success:', res);
                if (res && res.success && res.data && typeof res.data.count !== 'undefined') {
                    applyCountToHeader(res.data.count);
                } else {
                    console.log('[Wishlist header] unexpected response shape');
                }
            },
            error: function (xhr) {
                console.log('[Wishlist header] ajax ERROR', xhr.status, xhr.responseText);
            }
        });
    }

    // --- Debug: ensure badge exists on page load ---
    // console.log('[Wishlist header] init. badge found:', getBadgeEl().length, getBadgeEl().get(0));

    // --- YITH events (if present) ---
    $(document).on('added_to_wishlist removed_from_wishlist', function (e) {
        // console.log('[YITH event]', e.type, 'fired');
        updateHeaderWishlistCount('event:' + e.type);
    });

    // --- Fallback: click-based hook ---
    $(document).on('click', '.add_to_wishlist, .remove_from_wishlist, .delete_item', function () {
        // console.log('[Wishlist click] clicked:', this);
        // give YITH ajax a moment to finish
        setTimeout(function () {
            updateHeaderWishlistCount('click-fallback');
        }, 600);
    });

    // --- initial sync ---
    updateHeaderWishlistCount('initial');

});
